import React, { useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
interface EmailCaptureFormProps {
  onSubmit: (email: string) => void;
  isSubmitted?: boolean;
  submittedEmail?: string;
  className?: string;
  isSubmitting?: boolean;
  error?: string | null;
}
export const EmailCaptureForm = ({
  onSubmit,
  isSubmitted = false,
  submittedEmail = '',
  className = '',
  isSubmitting = false,
  error = null
}: EmailCaptureFormProps) => {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const emailInput = (e.target as HTMLFormElement).email.value;
    if (emailInput) {
      setEmail(emailInput);
      onSubmit(emailInput);
    }
  };
  return <form onSubmit={handleSubmit} className={`relative max-w-[520px] w-full ${className}`} data-id="element-351">
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-0" data-id="element-352">
        <div className={`relative w-full flex items-center rounded-full shadow-sm border transition-all duration-200
            ${isSubmitted ? 'bg-[#F9FAFB] border-[#AEA2F6]' : 'bg-white border-gray-200 group hover:border-[#E9E7FD] hover:shadow-[0_0_6px_2px_rgba(156,142,245,0.25)] focus-within:shadow-[0_0_6px_2px_rgba(156,142,245,0.25)] focus-within:border-[#E9E7FD]'}`} data-id="element-353">
          <input type="email" name="email" value={isSubmitted ? submittedEmail : undefined} placeholder="Enter Your Work Email" pattern="^[a-zA-Z0-9._%+-]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!.*\.co\.uk$)(?!.*\.fr$)(?!.*\.de$)(?!.*\.it$)(?!.*\.br$)(?!.*\.ru$)(?!.*\.edu$)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" className={`w-full h-12 sm:h-14 pl-6 pr-32 rounded-full bg-transparent text-gray-600 placeholder-gray-500 focus:outline-none text-base`} readOnly={isSubmitted || isSubmitting} required title="Enter a valid work email address" data-id="element-354" />
          {isSubmitted && <div className="absolute right-6 top-1/2 -translate-y-1/2 text-[#8679DF]" data-id="element-355">
              <CheckCircleIcon size={24} data-id="element-356" />
            </div>}
        </div>
        {!isSubmitted && <button type="submit" disabled={isSubmitting} className={`h-10 px-5 bg-[#8679DF] text-white font-semibold rounded-full transition-all duration-200 hover:bg-[#7668CE] hover:shadow-md disabled:opacity-70 disabled:cursor-not-allowed w-full sm:w-auto sm:absolute sm:right-2 sm:top-1/2 sm:-translate-y-1/2`} data-id="element-357">
            {isSubmitting ? 'Joining...' : 'Get Early Access'}
          </button>}
      </div>
      {error && <p className="text-red-500 text-sm mt-2" data-id="element-358">{error}</p>}
    </form>;
};